module.exports = __webpack_public_path__ + "r-v3/img/exam_mark_part.b979ac2a.svg";